/* eslint-disable no-param-reassign -- Redux Toolkit uses Immer */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type LiveFormBannerType } from '../../../shared/constants';

export interface LiveFormState {
  alerts: {
    isVisible: boolean;
    bannerType: string | null;
    bannerMessage: string | null;
  };
}

const initialState = {
  alerts: {
    isVisible: false,
    bannerType: null as LiveFormBannerType | null,
    bannerMessage: null as string | null,
  },
};

const liveFormSlice = createSlice({
  name: 'liveForm',
  initialState,
  reducers: {
    showLiveAlert: (
      state,
      action: PayloadAction<{
        bannerType: LiveFormBannerType;
        bannerMessage?: string;
      }>
    ) => {
      state.alerts.isVisible = true;
      state.alerts.bannerType = action.payload.bannerType;
      state.alerts.bannerMessage = action.payload.bannerMessage ?? null;
    },
    hideLiveAlert: (state) => {
      state.alerts.isVisible = false;
      state.alerts.bannerType = null;
      state.alerts.bannerMessage = null;
    },
  },
});

// Unified actions export for this slice
export const liveFormActions = liveFormSlice.actions;

// Reducer exports (both default and named for convenience)
export const liveFormReducer = liveFormSlice.reducer;
export default liveFormSlice.reducer;
